import type { IngredientCategory } from "@/lib/types";
import type { CreateIngredientFormData } from "../form";
import { ingredientNumericFields, ingredientValueToDisplay } from "../units";
import { prepareNutrition } from "./prepare";
import type { NutritionCategoryAdapter } from "./types";

export function nutritionFormAdapter(
  category: IngredientCategory,
): NutritionCategoryAdapter {
  return {
    category,
    derive(draft) {
      const prepared = prepareNutrition(category, draft);
      const formPatch: Partial<CreateIngredientFormData> = {};
      for (const field of ingredientNumericFields) {
        if (field === "dairyFatPct") continue;
        formPatch[field] = ingredientValueToDisplay(
          field,
          prepared.values[field],
        );
      }
      return {
        formPatch,
        estimatedWaterPct: prepared.estimatedWaterPct * 100,
        blockingIssues: prepared.issues.map((issue) => ({
          title: issue.message,
        })),
        derivation: prepared.derivation,
      };
    },
  };
}
